module.exports = __webpack_public_path__ + "static/media/T0.004d877d.svg";